module.exports = __webpack_public_path__ + "img/th-1999x1999-cardie.png.419d5f10.jpg";